import React, { useEffect, useRef, useState } from 'react'
import '../Style/Product_list.css'
import Product_Component from '../Components/Product'
import SearchIcon from '../Logos/search.svg'
import { useParams } from 'react-router-dom'
import ShowMessage from '../Components/ShowMessage'
import axios from 'axios'
import Loading_Screen from '../Components/Loading_Screen'

function Product() {

    const Product_Search_Input_Ref = useRef()
    const Product_Search_Input_Text_Ref = useRef()
    
    const [Loading, SetLoading] = useState(true)

    const [Product_Data, SetProductData] = useState([])
    const { ProductSection } = useParams()
    const ErroPlace = useRef()

    useEffect(() => {
        axios.post("http://127.0.0.1:3001/get-products", { ProductSection })
            .then(data => {
                SetProductData(data.data)
            })
            .catch(err => { console.log(err) })
            .finally(
                SetLoading(false)
            )

        Product_Search_Input_Ref.current.addEventListener("focus", () => {
            Product_Search_Input_Text_Ref.current.style.transform = "translateY(-14px)"
            Product_Search_Input_Text_Ref.current.style.fontSize = "12px"
            Product_Search_Input_Text_Ref.current.style.width = "60px"

        });
        Product_Search_Input_Ref.current.addEventListener("focusout", () => {
            if (!Product_Search_Input_Ref.current.value.length > 0) {
                Product_Search_Input_Text_Ref.current.style.transform = "translateY(0px)"
                Product_Search_Input_Text_Ref.current.style.fontSize = "17px"
                Product_Search_Input_Text_Ref.current.style.width = "80px"
            }

        });
    }, [])
    return (
        <>
            <main>
                {Loading ? <Loading_Screen /> : null}
                <div className='error-place' ref={ErroPlace}></div>
                <div className='product-container'>
                    <div className='product-list'>
                        {Product_Data.map((Products, Key) => {
                            return <Product_Component Product_Data={Products} />
                        })}
                    </div>
                    <div className='product-search-container'>
                        <div className='product-search-by-name'>
                            <div className='title'>
                                <div className='text'>جست و جو بر اساس اسم</div>
                                <div className='wrapper'></div>
                            </div>
                            <div className='search-text' ref={Product_Search_Input_Text_Ref}>جست و جو</div>
                            <img src={SearchIcon} alt='search-icon' />
                            <input type='text' name='product-search' className='product-search-input' ref={Product_Search_Input_Ref} />
                        </div>

                        <div className='product-filter-by-price'>
                            <div className='title'>
                                <div className='text'>فیلتر بر اساس قیمت</div>
                                <div className='wrapper'></div>
                            </div>
                            <div className='options-container'>
                                <div className='option-row'>
                                    <div className='text'>5,000 تومان الی 20,000</div>
                                    <input type='checkbox' name='5k_20K' id='price-options' />
                                </div>
                                <div className='option-row'>
                                    <div className='text'>20,000 تومان الی 50,000</div>
                                    <input type='checkbox' name='20k_50K' id='price-options' />
                                </div>
                                <div className='option-row'>
                                    <div className='text'>50,000+ تومان</div>
                                    <input type='checkbox' name='50kup' id='price-options' />
                                </div>
                            </div>
                        </div>

                        <div className='product-filter-by-color'>
                            <div className='title'>
                                <div className='text'>فیلتر بر اساس رنگ</div>
                                <div className='wrapper'></div>
                            </div>
                            <div className='options-container'>
                                <div className='option-row'>
                                    <div className='text'>سیاه</div>
                                    <input type='checkbox' name='5k_20K' id='price-options' />
                                </div>
                                <div className='option-row'>
                                    <div className='text'>سفید</div>
                                    <input type='checkbox' name='20k_50K' id='price-options' />
                                </div>
                                <div className='option-row'>
                                    <div className='text'>سبز</div>
                                    <input type='checkbox' name='50kup' id='price-options' />
                                </div>
                                <div className='option-row'>
                                    <div className='text'>بنفش</div>
                                    <input type='checkbox' name='20k_50K' id='price-options' />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </>
    )
}

export default Product